export default __webpack_public_path__ + "static/media/Portaldick.d65f7538.PNG";